import { useEffect, useState } from 'react';
import {
  Alert,
  Anchor,
  Button,
  Container,
  Loader,
  Paper,
  Stack,
  Text,
  Title,
} from '@mantine/core';
import { IconCircleCheck, IconCircleX } from '@tabler/icons-react';
import { Link, useSearchParams } from 'react-router-dom';
import { authApi } from '../../shared/api/auth';
import { useAuthStore } from '../../shared/auth/auth.store';

type Status = 'pending' | 'ok' | 'error';

export function VerifyEmailPage() {
  const [params] = useSearchParams();
  const token = params.get('token') ?? '';
  const user = useAuthStore((s) => s.user);
  const setUser = useAuthStore((s) => s.setUser);

  const [status, setStatus] = useState<Status>('pending');
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  useEffect(() => {
    if (!token) {
      setStatus('error');
      setErrorMessage('Нет токена в ссылке');
      return;
    }
    authApi
      .verifyEmail(token)
      .then(() => {
        setStatus('ok');
        // Если юзер сидит в той же вкладке логиненным — освежим emailVerified
        // в локальном store, чтобы баннер «Подтвердите email» сразу исчез.
        if (user && !user.emailVerified) {
          setUser({ ...user, emailVerified: true });
        }
      })
      .catch((err) => {
        setStatus('error');
        setErrorMessage(err instanceof Error ? err.message : 'Не удалось подтвердить');
      });
  }, [token, user, setUser]);

  return (
    <Container size="xs" py="xl">
      <Title order={2} ta="center" mb="md">
        Подтверждение email
      </Title>
      <Paper withBorder shadow="sm" p="lg" radius="md">
        {status === 'pending' && (
          <Stack align="center">
            <Loader />
            <Text size="sm" c="dimmed">
              Проверяем токен...
            </Text>
          </Stack>
        )}
        {status === 'ok' && (
          <Stack>
            <Alert color="green" icon={<IconCircleCheck size={20} />} title="Email подтверждён">
              Спасибо! Теперь вы можете пользоваться всеми функциями системы.
            </Alert>
            <Button component={Link} to={user ? '/' : '/login'} fullWidth>
              {user ? 'В кабинет' : 'Войти'}
            </Button>
          </Stack>
        )}
        {status === 'error' && (
          <Stack>
            <Alert color="red" icon={<IconCircleX size={20} />} title="Не удалось подтвердить">
              {errorMessage ?? 'Токен невалидный или истёк.'}
            </Alert>
            <Text size="sm" c="dimmed">
              Войдите в кабинет и нажмите «Отправить ещё раз» в баннере подтверждения.
            </Text>
            <Anchor component={Link} to="/login" ta="center">
              Перейти к входу
            </Anchor>
          </Stack>
        )}
      </Paper>
    </Container>
  );
}
